/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import './bugsnag'
import {ErrorHandler, NgModule} from '@angular/core';
import {RoutingModule} from './routing.module';
import {AppComponent} from './app.component';
import {AuthGuard} from './_guards/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptor} from './_guards/oauth.interceptor';
import {ToastrModule} from 'ngx-toastr';
import {DialogHelper} from './_helpers/dialog-helper';
import {PagesModule} from './pages/pages.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {TOASTR_CONFIG} from './_enums/constants';
import {BugsnagErrorHandler} from '@bugsnag/plugin-angular';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

@NgModule({
  bootstrap: [
    AppComponent
  ],
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    PagesModule,
    RoutingModule,
    ToastrModule.forRoot(TOASTR_CONFIG),
    NgbModule
  ],
  providers: [
    AuthGuard,
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor
    },
    DialogHelper,
    { provide: new ErrorHandler(),  useFactory: errorHandlerFactory }
  ]
})

export class AppModule {
}
